import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import BackLink from '../future-packages/back-link';
import {
  MyCarsContentWrapper,
  LoanDetailWrapper,
  SpinnerWrapper,
} from './LoanDetail.styles';
import LoanDetailCard from './loan-detail-card/LoanDetailCard';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import { useDualEventTracking } from '../../utils/useDualEventTracking';

const LoanDetail = () => {
  const { id }: any = useParams();
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('view_loan', { vehicleId: id }), []);

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(id);

  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner data-testid="spinner" />
      </SpinnerWrapper>
    );
  }

  return (
    <LoanDetailWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="navigate_back_to_my_cars_tap"
          backLinkText="Back to My Cars"
          backLinkRoute="/"
        />
        <LoanDetailCard vehicleId={id} />
      </MyCarsContentWrapper>
    </LoanDetailWrapper>
  );
};

export default LoanDetail;
